import FormControl from "react-bootstrap/FormControl";
import FormGroup from "react-bootstrap/FormGroup";
import Select from "../Select";

const SignupField = ({
  id,
  label,
  type = "text",
  mandatory = false,
  prefix = "signup",
  min = null,
  max = null,
  defaultValue = null,
  multiple = null,
  options = [],
  onChange = null,
  placeholder = null,
}) => {
  const elementId = `${prefix}-${id}`;
  const opts = {
    type,
    id: elementId,
  };

  if (min !== null) {
    opts.min = min;
  }

  if (max !== null) {
    opts.max = max;
  }

  if (defaultValue !== null) {
    opts.defaultValue = defaultValue;
  }

  if (multiple) {
    opts.multiple = true;
  }

  if (onChange) {
    opts.onChange = onChange;
  }

  if (placeholder) {
    opts.placeholder = placeholder;
  }

  return (
    <FormGroup className="mb-3">
      <label className="form-label" htmlFor={`${prefix}-${id}`}>
        {(mandatory ? "* " : "") + label}
      </label>

      {type === "select" ? (
        <Select
          id={elementId}
          multiple={multiple}
          defaultValue={defaultValue}
          options={options}
          onChange={onChange}
          placeholder={placeholder}
        />
      ) : (
        <FormControl {...opts} />
      )}
    </FormGroup>
  );
};

export default SignupField;
